// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// Material icon
import CloseIcon from 'vue-material-design-icons/Close.vue'
import CloseCircleOutline from 'vue-material-design-icons/CloseCircleOutline.vue'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
import ArrowDownIcon from 'vue-material-design-icons/ArrowDown.vue'
import ArrowLeftIcon from 'vue-material-design-icons/ArrowLeft.vue'
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue'
import MapMarkerIcon from 'vue-material-design-icons/MapMarker.vue'
import PhoneIcon from 'vue-material-design-icons/Phone.vue'
import WebIcon from 'vue-material-design-icons/Web.vue'
import MapMarkerPathIcon from 'vue-material-design-icons/MapMarkerPath.vue'
import AccountCircleOutlineIcon from 'vue-material-design-icons/AccountCircleOutline.vue'
import FacebookIcon from 'vue-material-design-icons/Facebook.vue'
import TwitterIcon from 'vue-material-design-icons/Twitter.vue'
import LinkedinIcon from 'vue-material-design-icons/Linkedin.vue'
import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue'
import MapMarkerPlusIcon from 'vue-material-design-icons/MapMarkerPlus.vue'
import DeleteIcon from 'vue-material-design-icons/Delete.vue'
import PencilIcon from 'vue-material-design-icons/Pencil'
import PlusIcon from 'vue-material-design-icons/Plus'
import InformationIcon from 'vue-material-design-icons/Information'
import EmailIcon from 'vue-material-design-icons/Email'
import CartIcon from 'vue-material-design-icons/Cart'
import Leaf from 'vue-material-design-icons/Leaf'
import MapMarkerLeftIcon from 'vue-material-design-icons/MapMarkerLeft.vue'

// Transition
import Transitions from 'vue2-transitions'
// Leaflet global
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
// Toasted
import Toasted from 'vue-toasted'
Vue.component('close-icon', CloseIcon)
Vue.component('close-icon-outline', CloseCircleOutline)
Vue.component('magnify-icon', MagnifyIcon)
Vue.component('arrow-down-icon', ArrowDownIcon)
Vue.component('arrow-left-icon', ArrowLeftIcon)
Vue.component('arrow-right-icon', ArrowRightIcon)
Vue.component('map-maker-icon', MapMarkerIcon)
Vue.component('phone-icon', PhoneIcon)
Vue.component('web-icon', WebIcon)
Vue.component('map-marker-path-icon', MapMarkerPathIcon)
Vue.component('account-circle-outline-icon', AccountCircleOutlineIcon)
Vue.component('facebook-icon', FacebookIcon)
Vue.component('twitter-icon', TwitterIcon)
Vue.component('linkedin-icon', LinkedinIcon)
Vue.component('alert-circle-icon', AlertCircleIcon)
Vue.component('map-marker-plus-icon', MapMarkerPlusIcon)
Vue.component('plus-icon', PlusIcon)
Vue.component('delete-icon', DeleteIcon)
Vue.component('pencil-icon', PencilIcon)
Vue.component('information-icon', InformationIcon)
Vue.component('email-icon', EmailIcon)
Vue.component('cart-icon', CartIcon)
Vue.component('leaf-icon', Leaf)
Vue.component('map-marker-left-icon', MapMarkerLeftIcon)
Vue.use(Transitions)

Vue.config.productionTip = false

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)
Vue.use(Toasted)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js